import { getApplication } from '@ms/yammer-telemetry';
import { useMemo } from 'react';

type UseAppType = () => ReturnType<typeof getApplication>;
export const useAppType: UseAppType = () => useMemo(() => getApplication(), []);
